import { FIELDS } from '@/pages/SalesOrders/components/SalesOrderLines/constants';

const defaultFields = [
  {
    field: 'selectcommands',
    title: ' ',
    cell: 'selectcommands',
    headerCell: 'selectCommandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },
  {
    key: 'Id',
    field: FIELDS.ID,
    title: ' Id',
    label: 'Id',
    sortable: true,
    hidden: true,
    width: 50,
  },
  {
    key: 'PartNumber',
    field: FIELDS.PART_NUMBER,
    title: 'Part No',
    label: 'Part No',
    cell: 'navigation',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Quantity',
    field: FIELDS.QUANTITY,
    title: 'Qty',
    label: 'Quantity',
    sortable: true,
    hidden: false,
    width: 70,
  },
  {
    key: 'QuantityAllocated',
    field: FIELDS.QUANTITY_ALLOCATED,
    title: 'Allocated',
    label: 'Allocated',
    sortable: true,
    hidden: true,
    width: 70,
  },
  {
    key: 'AllocatedCost',
    field: FIELDS.ALLOCATED_COST,
    title: ' Allocated Cost',
    label: 'AllocatedCost',
    sortable: true,
    hidden: true,
    width: 70,
  },
  {
    key: 'QuantityBackodered',
    field: FIELDS.QUANTITY_BACKODERED,
    title: 'Backodered',
    label: 'Backodered',
    sortable: true,
    hidden: true,
    width: 70,
  },
  {
    key: 'QuantityInbound',
    field: FIELDS.QUANTITY_INBOUND,
    title: 'Inbound',
    label: 'Inbound',
    sortable: true,
    hidden: true,
    width: 70,
  },
  {
    key: 'QuantityShipped',
    field: FIELDS.QUANTITY_SHIPPED,
    title: 'Shipped',
    label: 'Shipped',
    sortable: true,
    hidden: true,
    width: 70,
  },
  {
    key: 'MfgName',
    field: FIELDS.MFG_NAME,
    title: ' Mfr',
    label: 'Mfr',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Description',
    field: FIELDS.DESCRIPTION,
    title: ' Description',
    label: 'Description',
    sortable: true,
    hidden: false,
    width: 500,
  },
  {
    key: 'Price',
    field: FIELDS.PRICE,
    title: ' Price',
    label: 'Price',
    cell: 'formatCurrency',
    sortable: true,
    hidden: false,
    width: 100,
  },
  {
    key: 'TotalPrice',
    field: FIELDS.TOTAL_PRICE,
    title: ' Total Price',
    label: 'TotalPrice',
    cell: 'formatCurrency',
    sortable: true,
    hidden: false,
    width: 100,
  },
  {
    key: 'DateCode',
    field: FIELDS.DATE_CODE,
    title: ' Date Code',
    label: 'DateCode',
    sortable: true,
    hidden: false,
    width: 100,
  },
  {
    key: 'LotCode',
    field: FIELDS.LOT_CODE,
    title: ' Lot Code',
    label: 'LotCode',
    sortable: true,
    hidden: false,
    width: 100,
  },
  {
    key: 'Revision',
    field: FIELDS.REVISION,
    title: ' Revision',
    label: 'Revision',
    sortable: true,
    hidden: false,
    width: 100,
  },
  {
    key: 'CountryOfOriginName',
    field: FIELDS.COUNTRY_OF_ORIGIN_NAME,
    title: 'COO',
    label: 'COO',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Condition',
    field: FIELDS.CONDITION,
    title: ' Condition',
    label: 'Condition',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'SalesOrderId',
    field: FIELDS.SALES_ORDER_ID,
    title: ' Sales Order',
    label: 'SalesOrderId',
    sortable: true,
    hidden: false,
    width: 70,
  },
  {
    key: 'Cost',
    field: FIELDS.COST,
    title: ' Cost',
    label: 'Cost',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'TotalCost',
    field: FIELDS.TOTAL_COST,
    title: ' Total Cost',
    label: 'TotalCost',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'Comments',
    field: FIELDS.COMMENTS,
    title: ' Comments',
    label: 'Comments',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'DueDate',
    field: FIELDS.DUE_DATE,
    title: ' Due Date',
    label: 'DueDate',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'TestingRequested',
    field: FIELDS.TESTING_REQUESTED,
    title: ' Testing Requested',
    label: 'TestingRequested',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'ShippingProviderId',
    field: FIELDS.SHIPPING_PROVIDER_ID,
    title: ' Shipping Provider Id',
    label: 'ShippingProviderId',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'ShippingProviderName',
    field: FIELDS.SHIPPING_PROVIDER_NAME,
    title: ' Shipping Provider Name',
    label: 'ShippingProviderName',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'ShippingMethodName',
    field: FIELDS.SHIPPING_METHOD_NAME,
    title: ' Shipping Method Name',
    label: 'ShippingMethodName',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'InternalPN',
    field: FIELDS.INTERNAL_PN,
    title: ' Internal PN',
    label: 'InternalPN',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'CustomerPN',
    field: FIELDS.CUSTOMER_PN,
    title: ' Customer PN',
    label: 'CustomerPN',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'AltNumber',
    field: FIELDS.ALT_NUMBER,
    title: ' Alt Number',
    label: 'AltNumber',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'NSNNumber',
    field: FIELDS.NSNNUMBER,
    title: ' NSNNumber',
    label: 'NSNNumber',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'SKU',
    field: FIELDS.SKU,
    title: ' SKU',
    label: 'SKU',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'ClassName',
    field: FIELDS.CLASS_NAME,
    title: ' Class Name',
    label: 'ClassName',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'CategoryName',
    field: FIELDS.CATEGORY_NAME,
    title: ' Category Name',
    label: 'CategoryName',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'UOM',
    field: FIELDS.UOM,
    title: ' UOM',
    label: 'UOM',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'Package',
    field: FIELDS.PACKAGE,
    title: ' Package',
    label: 'Package',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'PartComments',
    field: FIELDS.PART_COMMENTS,
    title: ' Part Comments',
    label: 'PartComments',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'CreatedByUserFullName',
    field: FIELDS.CREATED_BY_USER_FULL_NAME,
    title: ' Created By User Full Name',
    label: 'CreatedByUserFullName',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'ModifiedByUserFullname',
    field: FIELDS.MODIFIED_BY_USER_FULLNAME,
    title: ' Modified By User Fullname',
    label: 'ModifiedByUserFullname',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'DateCreated',
    field: FIELDS.DATE_CREATED,
    title: ' Date Created',
    label: 'DateCreated',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'DateModified',
    field: FIELDS.DATE_MODIFIED,
    title: ' Date Modified',
    label: 'DateModified',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'LeadFree',
    field: FIELDS.LEAD_FREE,
    title: ' Lead Free',
    label: 'LeadFree',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'TempRating',
    field: FIELDS.TEMP_RATING,
    title: ' Temp Rating',
    label: 'TempRating',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'isService',
    field: FIELDS.IS_SERVICE,
    title: 'Is Service',
    label: 'isService',
    sortable: true,
    hidden: true,
    width: 150,
  },  
  {
    field: 'deletecommands',
    title: ' ',
    cell: 'deletecommands',
    headerCell: 'commandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },
]

export default defaultFields;
